export function parseBands(text: string): Array<number> {
  const lines = text.split('\n');
  const result: Array<number> = [];
  for (const line of lines) {
    const parsed = parseInt(line, 10);
    if (!Number.isNaN(parsed)) {
      result.push(parsed);
    }
  }
  result.sort((a, b) => b - a);
  return result;
}
